<template>
  <div class="out-wrap">
    <st-loading :loading="fLoading" :title="fTitle"></st-loading>
    <st-header
      title="发 货"
      :back-able="true"
      :close-able="true"
    >
      <template slot="header-right">
        <!-- <span>
          更多
        </span> -->
      </template>
    </st-header>

    <div class="tab-content">
      <div class="st-list-box pan-1">
        <div class="st-list">
          <div class="st-list-top">
            <div class="t-tit">{{ info.ordercode }}</div>
          </div>
          <div class="st-list-main">
            <p>订单类型： {{ info.type_text }}订单</p>
						<p>客户： {{ info.customer }}</p>
						<p>物流方式： {{ info.shippingmethods_text }}</p>
          </div>
        </div>
      </div>

      <div class="st-list-box pan-1">
        <div class="st-list" v-for="(v, i) in info.skus" :key="v.id || i">
          <div class="st-list-top">
            <div class="t-tit">SKU： {{ v.sku }}</div>
            <div class="t-status"></div>
          </div>
          <div class="st-list-main">
            <p>品&emsp;&emsp;牌：{{ v.brand }}</p>
            <p>型&emsp;&emsp;号：{{ v.model }}</p>
						<p>可发货数量：{{ v.available_send_total }}</p>
            <p>已发货数量：{{ v.send_total }}</p>

						<st-form-item label="发货数量:" :prop="`items.${i}.send_total`">
						  <van-field
                clearable
						    class="st-form-item-input"
						    v-model="info['skus'][i]['send_total_input']"
						    name="发货数量"
						    label=""
						    placeholder="请输入发货数量"
						  />
						</st-form-item>

            <st-form-item label="Origin:" :prop="`items.${i}.origin`">
              <van-field class="st-form-item-input" v-model="info['skus'][i]['origin']" label="" placeholder="请输入Origin" />
            </st-form-item>

            <st-form-item label="Dimension:" :prop="`items.${i}.dimension`">
              <van-field class="st-form-item-input" v-model="info['skus'][i]['dimension']" label="" placeholder="请输入Dimension" />
            </st-form-item>

            <st-form-item label="NW净重:" :prop="`items.${i}.net_weight`">
              <van-field class="st-form-item-input" v-model="info['skus'][i]['net_weight']" label="" placeholder="请输入净重" />
            </st-form-item>

            <st-form-item label="GW毛重:" :prop="`items.${i}.gross_weight`">
              <van-field class="st-form-item-input" v-model="info['skus'][i]['gross_weight']" label="" placeholder="请输入毛重" />
            </st-form-item>

            <st-form-item label="Date Code:" :prop="`items.${i}.date_code`">
              <van-field class="st-form-item-input" v-model="info['skus'][i]['date_code']" label="" placeholder="请输入Date Code" />
            </st-form-item>
          </div>
        </div>
      </div>

      <div class="st-list-box pan-1">
        <div class="st-list">
          <div class="st-list-top">
            <div class="t-tit">物流信息</div>
          </div>
          <div class="st-list-main">
            <st-form-item label="送货方式:">
              <van-field
                readonly
                clickable
                is-link
                class="st-form-item-input"
                :value="deliveryText"
                label=""
                placeholder="请选择送货方式"
                @click="showDeliveryPicker = true"
              />
            </st-form-item>

            <st-form-item label="收件人:">
              <van-field class="st-form-item-input" v-model="form.receiver" label="" placeholder="请输入收件人" />
            </st-form-item>

            <st-form-item label="联系电话:">
              <van-field class="st-form-item-input" v-model="form.phone" label="" placeholder="请输入联系电话" />
            </st-form-item>

            <st-form-item label="城市:">
              <van-field class="st-form-item-input" v-model="form.city" label="" placeholder="请输入城市" />
            </st-form-item>

            <st-form-item label="收货地址:">
              <van-field class="st-form-item-input" v-model="form.address" label="" placeholder="请输入收货地址" />
            </st-form-item>

            <st-form-item label="入仓号:">
              <van-field class="st-form-item-input" v-model="form.warehouse" label="" placeholder="请输入入仓号" />
            </st-form-item>

            <st-form-item label="备注:">
              <van-field class="st-form-item-input" v-model="form.shipremark" label="" placeholder="请输入备注" />
            </st-form-item>

            <div class="upload-filed">
              <div style="float: left;">客户PO：</div>
              <st-file-upload v-model="pofileArr"></st-file-upload>
            </div>
          </div>
        </div>
      </div>

			<p class="st-van-btn-primary-p">
			  <van-button class="st-van-btn-primary" @click="submit()">
			    提&emsp;交
			  </van-button>
			</p>
    </div>

    <van-action-sheet
      v-model="showDeliveryPicker"
      :actions="deliveryActions"
      cancel-text="取消"
      close-on-click-action
      @select="onSelectDelivery"
    />


  </div>
</template>

<script>
import StFileUpload from "@/components/FileUpload.vue";
import StHeader from "@/components/layout/Header.vue";
import StLoading from "@/components/layout/FullLoading.vue";
import StFormItem from "@/components/formItem.vue";

export default {
  components: {
    'st-file-upload': StFileUpload,
    "st-header": StHeader,
    "st-loading": StLoading,
		"st-form-item": StFormItem,
  },
  props: {  },
  data() {
    return {
      fLoading: false, // 全屏加载
      fTitle: "提交中",
      info: {},
      pofileArr: [],
      showDeliveryPicker: false,
      deliveryActions: [
        { name: "客户自提", value: "1" },
        { name: "公司送货", value: "2" },
      ],
      form: {
        delivery: "",
        receiver: "",
        phone: "",
        city: "",
        address: "",
        warehouse: "",
        shipremark: "",
        pofile: "",
      },
    };
  },
  watch: {},
  computed: {
    deliveryText() {
      const deliveryMap = {
        "1": "客户自提",
        "2": "公司送货",
      };
      return deliveryMap[String(this.form.delivery || "")] || "";
    },
  },
	created() {
    this.init();
  },
  mounted() {
    this.resetPageInteraction();
  },
  beforeDestroy() {
    this.resetPageInteraction();
  },
  methods: {
    resetPageInteraction() {
      document.body.style.overflow = "auto";
      if (this.$toast && typeof this.$toast.clear === "function") {
        this.$toast.clear();
      }
    },
    init() {
      this.getInfo();
    },
    onSelectDelivery(action) {
      this.form.delivery = action.value;
      this.showDeliveryPicker = false;
    },
    getBackListRoute() {
      const type = this.$route.query && (this.$route.query.type === "1" ? "1" : "0");
      return `/saleo/list?type=${type}`;
    },

    // 获取详情 
    getInfo() {
      this.$post(this.$api.stGetXiaoshouoShipInfo, {id: this.$route.params.id}).then((res) => {
      	if (res.code == 200) {
          res.data.skus = (res.data.skus || []).map((v) => ({
            ...v,
            send_total_input: "",
            origin: "",
            dimension: "",
            net_weight: "",
            gross_weight: "",
            date_code: "",
          }));
      		this.info = res.data;
          this.form.delivery = res.data.delivery ? String(res.data.delivery) : "";
          this.form.receiver = res.data.receiver || "";
          this.form.phone = res.data.phone || "";
          this.form.city = res.data.city || "";
          this.form.address = res.data.address || "";
      	} else {
      		this.$toast.fail(res['msg'] ? res['msg'] : '请求异常');
      	}
      });
    },

    submit() {
      const skus = JSON.parse(JSON.stringify(this.info.skus || []));
      const prow = skus.map((v) => ({
        id: v.id,
        send_total: v.send_total_input ? v.send_total_input : 0,
        origin: v.origin || "",
        dimension: v.dimension || "",
        net_weight: v.net_weight || "",
        gross_weight: v.gross_weight || "",
        date_code: v.date_code || "",
      }));

      this.form.pofile = (this.pofileArr || []).map((v) => v.url).join(",");
      this.fLoading = true;
      let formData = {
				ids: this.$route.params.id,
				row: this.form,
				prow,
			};

      this.$post(this.$api.stSaleSend, formData).then((res) => {
        if (res.code !== 200) {
          this.$toast.fail(res.msg ? res.msg : '提交请求异常，请稍后重试！');
          this.fLoading = false;
        } else {
          this.resetPageInteraction();
          this.$toast.success('提交成功');
          this.fLoading = false;
					this.$router.replace(this.getBackListRoute());
        }
      }).catch((err) => {
        this.$toast.fail(err && err.msg ? err.msg : '提交请求异常，请稍后重试！');
        this.fLoading = false;
      });
    },

  },
};
</script>

<style lang="scss" scoped>
.upload-filed {
  overflow: hidden;
  margin-top: 12px;
  ::v-deep .avatar-uploader {
    float: left;
  }  
}

.out-wrap {
	position: relative;
	.st-list {
	  padding: 30px;
		margin: 24px;
		border-radius: 5px;
	}
	
	.st-van-btn-primary-p {
		position: sticky;
		bottom: 10px;
		
		.st-van-btn-primary {
			position: relative;
			left: 50%;
			transform: translateX(-50%);
		  width: 80%;
		}
	}
	
}

.van-field {
	box-shadow: inset 0 0 0 2px rgb(223,223,223);
	border-radius: 5px;
}

</style>
